import { ApplicationForm } from "@/blocks/ApplicationForm";
import { EligibilityScreenLayout } from "@/blocks/EligibilityScreenLayout";

const EligibilityResultsScreen = () => {
  return (
    <EligibilityScreenLayout>
      <ApplicationForm formType="eligibilityResults" />
    </EligibilityScreenLayout>
  );
};

export { EligibilityResultsScreen };
